/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CountryResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Countries<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags countries
   * @name FindAll
   * @request GET:/countries
   * @secure
   */
  findAll = (params: RequestParams = {}) =>
    this.request<CountryResponse[], any>({
      path: `/countries`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
